module.exports = __webpack_public_path__ + "images/entrepreneur-of-year-c4449a.png";